import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2bf69c23&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2bf69c23&prod&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=2bf69c23&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf69c23",
  null
  
)

export default component.exports